import React from 'react'

function CallToAction() {
  return (
    <div className="cta">
      <h2>
        Try affio&apos;s online Will writing service. It&apos;s free to start!
      </h2>{' '}
      <a
        className="et_pb_promo_button"
        href="https://app.affio.co.uk/#/register"
      >
        Click here to start
      </a>
    </div>
  )
}

export default CallToAction
